import { GeneralListRequest, KeyValPair } from '@models/common.model'
import { OrganizationInfo } from '@models/organization.model'
import { ProductsInfo } from '@models/products.model'
import { ProjectInfo } from '@models/projects.model'
import API  from '../index'

const GetCategoryMetadata = async (category: string) => {
    return await API.get<KeyValPair[]>(`/api/common/key-values?category=${category}`).then((rep) => {
      return rep.data
    })
}

const GetProjectList = async (req: GeneralListRequest) => {
  return await API.post<{data: ProjectInfo[], total_count: number} >(`/api/v2/projects/search`, req).then((rep)=>{
    return rep.data.data
  })
}

const GetOrganizationList = async (req: GeneralListRequest) => {
  return await API.post<{data: OrganizationInfo[], total_count: number}>(`/api/v2/organizations/search`, req).then((rep)=>{
    return rep.data.data
  })
}

const GetProductsList = async (req: GeneralListRequest) => {
  return await API.post<{data: ProductsInfo[], total_count: number}>(`/api/v2/products/search`, {}).then((rep)=>{
    return rep.data.data
  })
}

const CommonService = {
    GetCategoryMetadata,
    GetProjectList,
    GetOrganizationList,
    GetProductsList
}

export default CommonService